// Fix header to viewport
(function (w, d, namespace) {
  let wrapper = d.querySelector(`.${namespace}`),
      wrapperParent = wrapper.parentElement,
      wrapperFixedVariant = `${namespace}-fixed`,
      measurement = offset(wrapperParent),
      lastScrollTop = 0

  function offset (el) {
    if (el === null) return {}

    let rect = el.getBoundingClientRect(),
        docEl = d.documentElement,
        results = {
          top: rect.top + w.pageYOffset || docEl.scrollTop,
          left: rect.left + w.pageXOffset || docEl.scrollLeft,
          height: rect.height
        }

    results.bottom = results.top + results.height
    return results
  }

  function resetHeader () {
    wrapper.style.transform = ''
    wrapper.classList.remove(wrapperFixedVariant)
    wrapperParent.style.height = null
  }

  function showHeader () {
    if (!wrapper.classList.contains(wrapperFixedVariant)) {
      wrapperParent.style.height = `${measurement.height}px`
      wrapper.classList.add(wrapperFixedVariant)
      wrapper.style.transform = 'translateY(0)'
    }
  }

  function hideHeader () {
    if (wrapper.classList.contains(wrapperFixedVariant)) {
      wrapper.style.transform = 'translateY(-100%)'
      setTimeout(resetHeader, 100)
    }
  }

  function fixToViewport () {
    let breakpointer = offset(d.querySelector(`.rnk-Hero_NavBar`)),
        isMobile = d.body.classList.contains('offcanvas'),
        breakpoint = measurement.bottom - breakpointer.height
    const mobileHeaderHeight = 55

    breakpoint = isMobile ? (breakpoint - mobileHeaderHeight) : breakpoint

    if ((breakpoint - w.scrollY) > 0) {
      hideHeader()
    } else {
      showHeader()
    }
  }

  w.addEventListener('scroll', () => {
    fixToViewport()
  });

})(window, document, 'rnk-Hero_HeaderWrapper')
